import { useEffect, useRef, useState } from "preact/hooks";
import { mailHash, navigate } from "../router";
import { partLabel, queryParts } from "../search-query";
import { descriptionOf } from "../smart-search";

const go = (parts: string[]) => {
  const query = parts.join(" ").trim();
  navigate(mailHash(query ? `#/search/${encodeURIComponent(query)}` : "#/"));
};

const Chip = ({ part, onChange }: { part: string; onChange: (next: string) => void }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(part);
  const input = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (editing) input.current?.select();
  }, [editing]);
  if (editing)
    return (
      <span class="chip editing">
        <input
          ref={input}
          aria-label="Edit filter"
          value={value}
          size={Math.max(value.length, 4)}
          onInput={(event) => setValue((event.target as HTMLInputElement).value)}
          onBlur={() => {
            setEditing(false);
            if (value.trim() !== part) onChange(value.trim());
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") (event.target as HTMLInputElement).blur();
            if (event.key === "Escape") {
              setValue(part);
              setEditing(false);
            }
          }}
        />
      </span>
    );
  return (
    <span class="chip">
      <button
        type="button"
        class="chip-label"
        title="Edit"
        onClick={() => {
          setValue(part);
          setEditing(true);
        }}
      >
        {partLabel(part)}
      </button>
      <button type="button" aria-label={`Remove ${partLabel(part)}`} onClick={() => onChange("")}>
        ×
      </button>
    </span>
  );
};

/** The search's filters as chips: click one to edit it, × to drop it. */
export const SearchChips = ({ query }: { query: string }) => {
  const parts = queryParts(query);
  const description = descriptionOf(query);
  if (parts.length === 0) return null;
  return (
    <div class="search-chips">
      {description && (
        <span class="search-chips-from" title={description}>
          Results for “{description}”
        </span>
      )}
      {parts.map((part, index) => (
        <Chip
          key={`${index}:${part}`}
          part={part}
          onChange={(next) => go(parts.map((entry, at) => (at === index ? next : entry)))}
        />
      ))}
      {description && (
        <button type="button" class="link" onClick={() => go([description])}>
          Search the words instead
        </button>
      )}
    </div>
  );
};
